<template>
    <div id="how-it-works-business">
        <!--=====================================-->
        <!--=      About  Quality Area Start    =-->
        <!--=====================================-->
        <section class="section section-padding bg-color-light-gray mb--50 sunflower-supplier">
            <div class="container">
                <div class="section-heading mb--100">
                    <span class="subtitle primary bold">¿Cómo funciona?</span>
                    <h2 class="font-weight-100">Pasos a <span class="bold">seguir</span>.</h2>
                </div>
                <div class="row justify-content-center ml--5">
                    <div class="col-lg-5" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                        <div class="about-quality active">
                            <div class="bullet cursor-icon" :style="`background-image: url(${img2});`"></div>
                            <h5 class="title black">1. Regístrate.</h5>
                            <p class="black w-75 text-wrap-balance">
                                Crea y verifica una cuenta de inversionista.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-5" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                        <div class="about-quality">
                            <div class="bullet cursor-icon" :style="`background-image: url(${img1});`"></div>
                            <h5 class="title black">2. Prepárate.</h5>
                            <p class="black w-75 text-wrap-balance">
                                Genera tu código y capacítate
                                para conocer los detalles
                                más importantes de la inversión
                                en RedGirasol.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-5" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300">
                        <div class="about-quality">
                            <div class="bullet card-icon" :style="`background-image: url(${img4});`"></div>
                            <h5 class="title black">3. Promueve.</h5>
                            <p class="black w-75 text-wrap-balance">
                                Invita a tu círculo a invertir en RedGirasol.
                                Asegúrate de que se registren
                                con tu código personalizado.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-5" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400">
                        <div class="about-quality">
                            <div class="bullet card-icon" :style="`background-image: url(${img3});`"></div>
                            <h5 class="title black">4. Cobra.</h5>
                            <p class="black w-75 text-wrap-balance">
                                El día 15 de cada mes recibirás
                                las comisiones correspondientes
                                a las inversiones del mes anterior.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "HowItWorks",
    components: {
    },
    data() {
        return {
            img1: "https://cdn.redgirasol.com/nuevo_portal/icons/cursor-icon.png",
            img2: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-promoters-user.png",
            img3: "https://cdn.redgirasol.com/nuevo_portal/icons/coin-icon.png",
            img4: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-promoters-love.png",
        }
    }
}

</script>

<style scoped>

#how-it-works-business {
    /* position: relative; */
    /* top: -18rem; */
    z-index: 0;
    /* height: 25rem; */
}

@media only screen and (max-width: 575px) {
    #how-it-works-business {
        position: inherit;
        height: 100%;
    }
}

@media only screen and (max-width: 991px) {
    #how-it-works-business {
        position: inherit;
        height: 100%;
    }
}

.p-width {
    width: 15rem !important;
}

.bullet {
    background-repeat: no-repeat;
    background-size: 4.5rem;
    /* background-position-x: 1rem; */
}

.bullet.cursor-icon {
    background-size: 3.5rem !important;
    background-position-x: 1rem !important;
}

.bullet.card-icon {
    border-radius: 0 !important;
    background-position-y: center;
    background-position-x: center;
}
</style>